import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { TokenService } from '../core/token.service';

/**
 * AuthGuard — Angular 17+ functional guard (CanActivateFn).
 *
 * Checks TokenService for a valid (non-expired) session.
 * If no valid session exists, redirects to /auth/login.
 *
 * Requirements: 9.3
 */
export const authGuard: CanActivateFn = () => {
  const tokenService = inject(TokenService);
  const router = inject(Router);

  if (tokenService.isAuthenticated()) {
    return true;
  }

  return router.createUrlTree(['/auth/login']);
};
